<template>
	<nav class="spofaq-searchapp__result-categories">
		<template v-for="category in categories">
			<Category
				:key="category.id"
				:category="category"
				:selectedCategory="selectedCategory"
				:status="status"
				v-on:filter-category="filterCategories"
				v-if="category.count > 0"
			>
			</Category>
		</template>
	</nav>
</template>

<script>
import Category from "./Category";
export default {
	name: "Categories",
	components: {
		Category
	},
	props: ["categories", "selectedCategory", "status"],
	methods: {
		filterCategories(cat) {
			this.$emit("filter-categories", cat);
		}
	}
};
</script>

<style scoped></style>
